export default {
  // If we want to change what we consider mobile we can just change it here in one place (instead of updating all the views)
  isMobile: breakpoint => breakpoint.smAndDown,
};
